import { render } from "./MyPackagesComponent.vue?vue&type=template&id=17ed91e9&scoped=true"
import script from "./MyPackagesComponent.vue?vue&type=script&lang=js"
export * from "./MyPackagesComponent.vue?vue&type=script&lang=js"

import "./MyPackagesComponent.vue?vue&type=style&index=0&id=17ed91e9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ed91e9"]])

export default __exports__